import { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Loader2, ShieldAlert } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";

export default function SsoPage() {
  const [params] = useSearchParams();
  const { ssoLogin } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const code = params.get("code");
    if (!code) return setError("Missing sign-in code.");
    ssoLogin(code).then((data) => {
      const to = data.return_to || "/";
      navigate(to.startsWith("/") ? to : "/", { replace: true });
    }).catch((e) => setError(formatApiError(e)));
  }, [params, ssoLogin, navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center p-6" data-testid="sso-page">
      <div className="rise w-full max-w-md space-y-5 text-center">
        <img src="/starandaisy-logo-white.png" alt="StarAndDaisy" className="mx-auto h-16 w-auto" />
        {error ? (
          <>
            <div className="flex items-center justify-center gap-2 rounded-sm border border-red-800 bg-red-950/40 px-3 py-3 text-sm text-red-300" data-testid="sso-error"><ShieldAlert className="h-4 w-4" /> {error}</div>
            <Button asChild className="bg-blue-600 hover:bg-blue-700"><Link to="/login" data-testid="sso-go-login">Go to sign in</Link></Button>
          </>
        ) : (
          <div className="flex items-center justify-center gap-2 font-mono text-xs uppercase tracking-widest text-slate-400" data-testid="sso-loading"><Loader2 className="h-4 w-4 animate-spin" /> Signing you in to Operations…</div>
        )}
      </div>
    </div>
  );
}
